import { render } from "./Configurations.vue?vue&type=template&id=64c77419&scoped=true"
import script from "./Configurations.vue?vue&type=script&lang=js"
export * from "./Configurations.vue?vue&type=script&lang=js"

import "./Configurations.vue?vue&type=style&index=0&id=64c77419&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c77419"]])

export default __exports__